import React, { memo, useCallback } from 'react';
import { format } from 'date-fns';
import { View, StyleSheet } from 'react-native';
import Logo from 'design-system/Logo';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import FlatListItemCard from 'design-system/FlatListItemCard';
import { formatAmount } from 'utils/formatting';
import useStockMeta from '../hooks/useStockMeta';
import { useCurrentPrice } from '../hooks/selectors';
import { StockAlertOptionsModal } from './StockAlertOptionsModal';
import useGetRealTimePrices from '../hooks/useGetRealTimePrices';
const StockAlert = ({ index, style, symbol, alertId, assetId, itemsLength, triggeredAt, alertPriceValue, alertPriceCurrency, }) => {
    const stockMeta = useStockMeta(assetId);
    const currentPrice = useCurrentPrice(assetId);
    useGetRealTimePrices(assetId);
    const handlePress = useCallback(() => {
        StockAlertOptionsModal.show(assetId, alertId, alertPriceValue, alertPriceCurrency);
    }, [alertId, alertPriceCurrency, alertPriceValue, assetId]);
    return (<FlatListItemCard index={index} style={style} itemsLength={itemsLength} onPress={triggeredAt ? undefined : handlePress}>
      <View style={styles.container}>
        <Logo R44 uri={stockMeta?.iconUrl} resizeMode="contain"/>
        <Spacer w={16}/>
        <View style={styles.flex}>
          <Text Text-16>
            1 ${symbol} = {formatAmount(alertPriceValue, alertPriceCurrency, 2)}
          </Text>
          {!!triggeredAt && (<Text TextThin-14 Secondary>
              Triggered on {format(triggeredAt, "d MMM 'at' H:mm")}
            </Text>)}
          {!!currentPrice && !triggeredAt && (<Text TextThin-14 Secondary>
              Current: {formatAmount(currentPrice.value, currentPrice.currency, 2)}
            </Text>)}
        </View>
      </View>
    </FlatListItemCard>);
};
export default memo(StockAlert);
const styles = StyleSheet.create({
    container: {
        padding: rem(16),
        alignItems: 'center',
        flexDirection: 'row',
    },
    flex: {
        flex: 1,
    },
});
